// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1YVIc","footer":"ReportModalFilter_footer__19oki"};